<template>
    <div class="BindPhonePopup">
      <popup ref="popup"
             type="center" :coverClose="false">
        <div class="con">
          <div class="icon_close" @click="close"><i class="el-icon-circle-close"></i> </div>
          <div class="title">根据监管部门要求，需先完成实名认证</div>
          <div class="title2">请填写以下个人信息，完成实名认证</div>
          <div class="steps">
            <div :class=" !item.pass? 'stepLists':'stepLists2'" v-for="(item,index) in stepList" :key="index">
              <div class="left">
                <div class="listNum">
                  {{ item.num }}
                </div>
                <p class="listTitle">{{ item.title }}</p>
              </div>
              <div class="right" v-if="item.num!==1">
  
              </div>
            </div>
          </div>
          <div class="input_item" v-if="showNum===1">
            <span>姓名</span> <span style="width:auto;margin: 0 10px 0 5px ;">：</span>
            <el-input placeholder="请输入真实姓名" v-model="cert_name" maxlength="20" clearable></el-input>
          </div>
          <div class="input_item" v-if="showNum===1">
            <span>身份证号</span><span style="width:auto;margin: 0 10px 0 5px ;">：</span>
            <el-input placeholder="请输入份证号" v-model="cert_no" maxlength="20"></el-input>
          </div>
          <div v-show="showNum===2" class="canvas_img">
            <canvas class="timeout" id="canvas"></canvas>
          </div>
          <div v-if="showNum===3" @click="okNo =!okNo" :class="okNo?'success':'error'" style="margin-top:50px; ">
            <img v-if="okNo" alt="" src="./img/AuthenticationOk/ok.png" height="64" width="64"/>
            <img v-else alt="" src="./img/AuthenticationOk/err.png" height="64" width="64"/>
            <p>{{ okNo?'恭喜您，实名认证成功':'对不起，认证失败' }}</p>
          </div>
          <div class="button_item">
            <div class="submit" @click="submit">{{ showNum === 1 || showNum === 2 ? '下一步' : '好的我知道了' }}</div>
            <!--          <el-button class="submit" type="primary" @click="submit">{{ showNum===1||showNum===2?'下一步':'好的我知道了'}}</el-button>-->
          </div>
          <!--        <div class="input_item" >-->
          <!--          <p class="tips" @click="close">稍后认证</p>-->
          <!--        </div>-->
        </div>
      </popup>
    </div>
  </template>
  <script type="text/ecmascript-6">
  import popup from "COMPONENTS/Popup.vue"
  import QRCode from 'qrcode'
  
  export default {
    components: {popup},
    data() {
      return {
        cert_name: '',
        cert_no: '',
        CertifyUrl: "",
        timer: null,
        showNum: 1,
        stepList: [
          {num: 1, title: '填写基本信息', pass: true,},
          {num: 2, title: '手机扫码认证', pass: false,},
          {num: 3, title: '认证成功', pass: false,},
        ],
        okNo:true,
      }
    },
    created() {
  
    },
    methods: {
  
      submit() {
        
        if(this.showNum == 2){
          // 显示二维码的 下一步
          this.$http.get("/front/auth/faceverify/check/").then((res) => {
            if (res.data.is_face_verify == 0) {
              this.$toast('请手机扫码完成实名认证！');
            }else{
              if (res.data.is_face_verify == 1){
                this.okNo = true
              }else if (res.data.is_face_verify == 2){
                this.okNo = false
              }
              this.showNum = 3
              this.stepList[2].pass = true
            }
          })
          return
        }
        if(this.showNum == 3){
          // 第三步
          this.close()
          return
        }
        let MetaInfo = getMetaInfo()
        if (!this.cert_name) {
          this.$toast('请填写真实姓名');
          return false;
        } else if (!this.cert_no) {
          this.$toast('请填写身份证号');
          return false;
        }
  
        this.$http.post('/front/auth/faceverify/', {
          cert_name: this.cert_name,
          cert_no: this.cert_no,
          MetaInfo: MetaInfo
        }).then(res => {
          if (res.status == '200') {
            this.showNum = 2
            this.stepList[1].pass = true 
           
            this.CertifyUrl = res.data.CertifyUrl;
            // location.href = CertifyUrl;
            var canvas = document.getElementById('canvas')
            QRCode.toCanvas(canvas, this.CertifyUrl, function (error) {
              if (error) console.error(error)
            })
            if (this.timer) {
              clearInterval(this.timer)
              this.timer = null
            }
            this.getFaceVerifyInfo()
          }else{

            this.$toast(res.message);
          }
        }).catch(res => {

          this.$toast(res.message);
        })
      },
      show() {
        this.showNum = 1
        this.stepList[1].pass = false
        this.stepList[2].pass = false
        this.cert_name = ""
        this.cert_no = ""
        this.$refs.popup.show();
      },
      close() {
        this.phone = ''
        this.code = ''
        this.$refs.popup.close();
        clearInterval(this.timer);
        this.timer = null
      },
      getFaceVerifyInfo() {
        // 获取认证结果
        this.timer = setInterval(() => {
          this.$http.get("/front/auth/faceverify/check/").then((res) => {
            if (res.data.is_face_verify == 1){
              this.okNo = true
              this.showNum = 3
              this.stepList[2].pass = true
              clearInterval(this.timer);
              this.timer = null
  
            }else if (res.data.is_face_verify == 2){
              this.okNo = false
              this.showNum = 3
              this.stepList[2].pass = true
  
              clearInterval(this.timer);
              this.timer = null
            }
          })
        }, 3000)
      },
    },
    beforeDestroy() {
    },
    destroyed() {
      clearInterval(this.timer);
    },
  };
  </script>
  <style rel="stylesheet/scss" lang="scss" scoped>
  .con {
    background: #fff;
    border-radius: 10px;
    //width: 460px;
    box-sizing: border-box;
    padding: 20px 60px;
    position: relative;
    .icon_close{
      position: absolute;
      top: 10px;
      right: 20px;
      font-size: 24px;
      cursor:pointer;
    }
  
    .title {
      font-size: 22px;
      padding: 20px 20px;
      text-align: center;
      font-weight: bold;
    }
  
    .title2 {
      color: #999999;
      font-size: 14px;
      padding: 0 0 20px 0;
      text-align: center;
    }
  
    .steps {
      width: 100%;
      min-width:415px ;
      //height:40px;
      //background-color: aquamarine;
      border: 1px dashed #999999;
      border-radius: 5px;
      padding: 15px 10px 15px 0;
      margin-bottom: 20px;
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
  
      .stepLists {
        position: relative;
        font-size: 12px;
        width: 110px;
  
        .left {
          display: flex;
          flex-direction: column;
          align-items: center;
  
          .listNum {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: #cccccc;
            color: #ababab;
            text-align: center;
            line-height: 20px;
            margin-bottom: 10px;
          }
  
          .listTitle {
            color: #ababab;
          }
        }
  
        .right {
          max-width: 125px;
          width: 125px;
          position: absolute;
          border-top: 1px dashed #999999;
          top: 10px;
          left: -80px;
        }
      }
  
      .stepLists2 {
        position: relative;
        font-size: 12px;
        width: 110px;
  
        .left {
          display: flex;
          flex-direction: column;
          align-items: center;
  
          .listNum {
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: #000000;
            color: #ffffff;
            text-align: center;
            line-height: 20px;
            margin-bottom: 10px;
          }
  
          .listTitle {
            color: #000000;
          }
        }
  
        .right {
          width: 140px;
          position: absolute;
          border-top: 1px dashed #000000;
          top: 10px;
          left: -100px;
        }
  
      }
    }
  
    .input_item {
      padding: 10px 0 20px;
      position: relative;
      display: flex;
      align-items: center;
  
      .input {
        //flex: 0 1;
        width: calc(100% - 80px);
        line-height: 80px;
        border: 1px solid #cfcfcf;
        border-radius: 6px;
        padding: 0 40px;
      }
  
      span {
        font-size: 14px;
        width: 100px;
        color: #ababab;
        text-align: justify;
        text-align-last: justify;
      }
  
      .get_code {
        display: block;
        width: 100px;
        height: 40px;
        line-height: 40px;
        text-align: center;
        position: absolute;
        top: 8px;
        right: 49px;
        color: #ec3b3b;
        cursor: pointer;
  
        &::after {
          content: "";
          display: block;
          height: 16px;
          border-left: 1px solid #ec3b3b;
          position: absolute;
          top: 12px;
          left: 0;
        }
      }
  
  
      .tips {
        text-align: center;
        //margin-bottom: 20px;
        color: #999;
        cursor: pointer;
      }
    }
    .canvas_img{
      display: flex;
      align-items: center;
      justify-content:center
    }
  
    .success {
      display: flex;
      flex-direction: column;
      align-items: center;
      img {
        width: 50px;
        height: 50px;
      }
  
      p {
        color:#2aa338;
        margin: 30px 0 30px;
      }
    }
    .error {
      display: flex;
      flex-direction: column;
      align-items: center;
  
      img {
        width: 50px;
        height: 50px;
      }
  
      p {
        color: #e22222;
        margin: 30px 0 30px;
      }
    }
  
    .button_item {
      display: flex;
      justify-content: flex-end;
      margin-bottom: 20px;
  
      .submit {
        width: 120px;
        display: block;
        //width: 100%;
        padding: 10px 0;
        text-align: center;
        background-color: #e22222;
        color: #fff;
        cursor: pointer;
        border-radius: 5px;
        margin-top: 10px;
      }
    }
  
  }
  </style>